// @ts-check
// @ts-check
import Dashboard from '../Pages/Dashboard';
import Login from '../Pages/Login';
import Routes1 from './Routes1';
import UDW from '../components/UDW';
import FormBuilder from '../components/UDW/FormBuilder';
import ClientMaintenanceRoutes from '../ClientMaintainanceRoutes';
import ClientSearch from '../Pages/ClientMaintainance/ClientSearch';
import LetterBatches from '../Pages/LetterBatches';
import LettersRequested from '../Pages/LettersRequested';
import ClientForm from '../Pages/ClientMaintainance/ClientSearch/ClientForm';
import ParentForm from '../Pages/ClientMaintainance/ClientSearch/ParentForm';
import ParentClient from '../Pages/ClientMaintainance/ClientSearch/ParentClient';
import Bre from '../Pages/FrameWorks/BRE';
import GlobalField from '../Pages/FrameWorks/GlobalFields/GlobalField/index';
import RateTable from '../Pages/RateTable';
import RateTable2 from '../Pages/RateTable2';
import RecordFormat from '../Pages/FrameWorks/RecordFormat';
import WorkQueue from '../Pages/Dashboard/WorkQueue';
import WorkQueueMaintenance from '../Pages/Dashboard/WorkQueueMaintenance';
import WorkQueueSetup from '../Pages/Dashboard/WorkQueueSetup';
import WQActivity from '../Pages/Dashboard/WQActivity';
import EventTactics from '../Pages/FrameWorks/EventTactics';
import EnableFramework from '../Pages/FrameWorks/EnableFramework';
import NightJobs from '../Pages/FrameWorks/NightJobs';
import SearchRoleManagement from '../Pages/RoleManagement/index';
import UserManagement from '../Pages/UserManagement/index';
import EventClientMaintenance from '../Pages/FrameWorks/EventClientMaintenance';
import ForgotPassword from '../Pages/Login/ForgotPassword';
import ChangePassword from '../Pages/Login/ChangePassword';
import ResetPassword from '../Pages/Login/ResetPassword';
import CbsLoginPage from '../Pages/CbsLoginPage';
import AddPatient from '../Pages/AddAccount';
import Triggers from '../Pages/FrameWorks/Triggers/index';
import WorkQueueList from '../Pages/Dashboard/WorkQueue/WorkQueueList.js';
import DataManager from '../Pages/FrameWorks/DataManager';
import EventTriggerGroup from '../Pages/FrameWorks/EventTriggerGroup';
import TriggerAccount from '../Pages/FrameWorks/TriggerAccount';
import Reports from '../Pages/FrameWorks/Reports';
import BreTabs from '../Pages/FrameWorks/BRE/Tabs';
import GlobalFieldList from '../Pages/FrameWorks/GlobalFields/GlobalFieldList';
import ImportManagerRecord from '../Pages/FrameWorks/DataManager/DataManagerRecord';
import ImportManager from '../Pages/FrameWorks/DataManager/DataManager';
import ExportManagerRecord from '../Pages/FrameWorks/DataManager/ExportManagerRecord';
import ImportManagerRecordGroup from '../Pages/FrameWorks/DataManager/ImportManagerRecordGroup';
import ExportManagerRecordGroup from '../Pages/FrameWorks/DataManager/ExportManagerRecordGroup';
import AuditFieldList from '../Pages/FrameWorks/GlobalFields/AuditFieldList';
import ClientAuditFieldList from '../Pages/FrameWorks/GlobalFields/ClientAuditFieldList';
import IntermediateRepository from '../Pages/FrameWorks/IntermediateRepository';
import BatchList from '../Pages/FrameWorks/Operations/NewBusiness';
import AccountList from '../Pages/FrameWorks/Operations/NewBusiness/WorkQueueList';
import AccountFields from '../Pages/FrameWorks/Operations/NewBusiness/AccountNumberFields';
import ClientOrganization from '../Pages/ClientOrganization/index';
import ClientTenants from '../Pages/ClientOrganization/index2';
import DmExecutionHistory from '../Pages/FrameWorks/DataManager/DmExecutionHistory';
import DmExportExecution from '../Pages/FrameWorks/DataManager/DmExecutionHistory/ExportExecutionHistory';
import SchedulerExecutionHistory from '../Pages/FrameWorks/SchedulerExecutionHistory';
import TranslationTable from '../Pages/TransitionTable';
import LookupMaintenance from '../Pages/LookupMaintenance';
import NewLetterMaintenance from '../Pages/NewLetterMaintenance';
import EdiExport from '../Pages/EdiExport/index';
import BillingIndicatorMaintenance from '../Pages/BillingIndicatorMaintenance/index';
import ErrorPage from '../util/ErrorPage';
/**
 * @typedef {Object} RouteConfig
 * @property {string} path - The path of the route.
 * @property {boolean} isPrivate - Is this a Private Route? Requires authentication.
 * @property {any} component - The component to render for the route.
 * @property {boolean} [private] - Whether the route is private.
 */

/** @type {RouteConfig[]} */
const routes = [
  {
    path: 'login',
    component: Login,
    isPrivate: false,
  },
  {
    path: 'reset-password',
    component: ResetPassword,
    isPrivate: false,
  },
  {
    path: 'forgot-password',
    component: ForgotPassword,
    isPrivate: false,
  },
  {
    path: 'cbs-login-age',
    component: CbsLoginPage,
    isPrivate: true,
  },
  {
    path: 'change-password',
    component: ChangePassword,
    isPrivate: true,
  },
  {
    path: 'patient-search',
    component: Dashboard,
    isPrivate: true,
  },
  {
    path: 'account-summary',
    component: Routes1,
    isPrivate: true,
  },
  {
    path: 'custom-window',
    component: UDW,
    isPrivate: true,
  },
  {
    path: 'client-maintenance',
    component: ClientMaintenanceRoutes,
    isPrivate: true,
  },
  {
    path: 'billing-indicator-maintenance',
    component: BillingIndicatorMaintenance,
    isPrivate: true,
  },
  {
    path: 'form-builder',
    component: FormBuilder,
    isPrivate: true,
  },
  {
    path: 'client-search',
    component: ClientSearch,
    isPrivate: true,
  },
  {
    path: 'frameworks/data-repository',
    component: GlobalField,
    isPrivate: true,
  },
  {
    path: 'frameworks/staging-repository',
    component: IntermediateRepository,
    isPrivate: true,
  },
  {
    path: 'frameworks/BRE',
    component: Bre,
    isPrivate: true,
  },
  {
    path: 'frameworks/data-calculation',
    component: BreTabs,
    isPrivate: true,
  },
  {
    path: 'frameworks/filter-rules',
    component: BreTabs,
    isPrivate: true,
  },
  {
    path: 'frameworks/field-list',
    component: GlobalFieldList,
    isPrivate: true,
  },
  {
    path: 'frameworks/audit-field-list',
    component: AuditFieldList,
    isPrivate: true,
  },
  {
    path: 'frameworks/client-audit-field-list',
    component: ClientAuditFieldList,
    isPrivate: true,
  },
  {
    path: 'new-business',
    component: BatchList,
    isPrivate: true,
  },
  {
    path: 'letters/letter-batches',
    component: LetterBatches,
    isPrivate: true,
  },
  {
    path: 'letters/letter-request',
    component: LettersRequested,
    isPrivate: true,
  },
  {
    path: 'Add-parent-form',
    component: ParentForm,
    isPrivate: true,
  },
  {
    path: 'new-business-maintenance/add-account',
    component: AddPatient,
    isPrivate: true,
  },
  {
    path: 'client-form',
    component: ClientForm,
    isPrivate: true,
  },
  {
    path: 'parent-client',
    component: ParentClient,
    isPrivate: true,
  },
  {
    path: 'rate-table',
    component: RateTable,
    isPrivate: true,
  },
  {
    path: 'rate-table2',
    component: RateTable2,
    isPrivate: true,
  },
  {
    path: 'frameworks/record-format',
    component: RecordFormat,
    isPrivate: true,
  },
  {
    path: 'frameworks/reports',
    component: Reports,
    isPrivate: true,
  },
  {
    path: 'role-management',
    component: SearchRoleManagement,
    isPrivate: true,
  },
  {
    path: 'user-management',
    component: UserManagement,
    isPrivate: true,
  },
  {
    path: 'lookup-maintenance',
    component: LookupMaintenance,
    isPrivate: true,
  },
  {
    path: 'frameworks/event-tactics/triggers',
    component: EventTactics,
    isPrivate: true,
  },
  {
    path: 'frameworks/event-tactics/trigger-group',
    component: Triggers,
    isPrivate: true,
  },
  {
    path: 'frameworks/event-tactics/event-trigger-group',
    component: EventTriggerGroup,
    isPrivate: true,
  },
  {
    path: 'frameworks/event-tactics/account-update-group',
    component: TriggerAccount,
    isPrivate: true,
  },
  {
    path: 'work-queue-maintenance',
    component: WorkQueueMaintenance,
    isPrivate: true,
  },
  {
    path: 'work-queue-setup',
    component: WorkQueueSetup,
    isPrivate: true,
  },
  {
    path: 'work-queue',
    component: WorkQueue,
    isPrivate: true,
  },
  {
    path: 'work-queue-activity',
    component: WQActivity,
    isPrivate: true,
  },
  {
    path: 'work-queue-list',
    component: WorkQueueList,
    isPrivate: true,
  },
  {
    path: 'batch-account-list',
    component: AccountList,
    isPrivate: true,
  },
  {
    path: 'frameworks/data-manager',
    component: DataManager,
    isPrivate: true,
  },
  {
    path: 'event-client-maintenance',
    component: EventClientMaintenance,
    isPrivate: true,
  },
  {
    path: 'frameworks/enable-framework',
    component: EnableFramework,
    isPrivate: true,
  },
  {
    path: 'frameworks/scheduler',
    component: NightJobs,
    isPrivate: true,
  },
  {
    path: 'scheduler-execution-history',
    component: SchedulerExecutionHistory,
    isPrivate: true,
  },
  {
    path: 'frameworks/import-template-record',
    component: ImportManagerRecord,
    isPrivate: true,
  },
  {
    path: 'frameworks/import-manager',
    component: ImportManager,
    isPrivate: true,
  },
  {
    path: 'frameworks/dm-import-execution-history',
    component: DmExecutionHistory,
    isPrivate: true,
  },
  {
    path: 'frameworks/dm-export-execution-history',
    component: DmExportExecution,
    isPrivate: true,
  },
  {
    path: 'frameworks/export-template-record',
    component: ExportManagerRecord,
    isPrivate: true,
  },
  {
    path: 'frameworks/export-manager',
    component: ImportManager,
    isPrivate: true,
  },
  {
    path: 'new-business-maintenance/new-account-fields',
    component: AccountFields,
    isPrivate: true,
  },
  {
    path: 'client-organization',
    component: ClientOrganization,
    isPrivate: true,
  },
  {
    path: 'client-tenants',
    component: ClientTenants,
    isPrivate: true,
  },
  {
    path: 'frameworks/import-manager-record-group',
    component: ImportManagerRecordGroup,
    isPrivate: true,
  },
  {
    path: 'frameworks/import-record-group',
    component: ImportManagerRecordGroup,
    isPrivate: true,
  },
  {
    path: 'frameworks/export-record-group',
    component: ExportManagerRecordGroup,
    isPrivate: true,
  },
  {
    path: 'transition-table',
    component: TranslationTable,
    isPrivate: true,
  },
  {
    path: 'letters/letter-maintenance',
    component: NewLetterMaintenance,
    isPrivate: true,
  },
  {
    path: 'frameworks-edi-export',
    component: EdiExport,
    isPrivate: true,
  },
  {
    path: 'frameworks-edi-import',
    component: EdiExport,
    isPrivate: true,
  },
  {
    path: '*',
    component: ErrorPage,
    isPrivate: false,
  },
];

export default routes;
